import { Link } from "react-router-dom";
import { Mail, Phone, Instagram, Facebook, Youtube } from "lucide-react";
import { Logo, NAV } from "./Navbar";
import { EMAIL, PHONE, PHONE_TEL } from "../../lib/site";
import { useSettings } from "../../lib/hooks";

const POLICIES = [
  { to: "/privacy-policy", label: "Privacy Policy" },
  { to: "/terms-and-conditions", label: "Terms & Conditions" },
  { to: "/cancellation-policy", label: "Cancellation Policy" },
];

export const Footer = () => {
  const s = useSettings();
  const socials = [
    { url: s?.instagram_url, Icon: Instagram, label: "Instagram" },
    { url: s?.facebook_url, Icon: Facebook, label: "Facebook" },
    { url: s?.youtube_url, Icon: Youtube, label: "YouTube" },
  ].filter((x) => x.url);
  return (
    <footer className="bg-[#171717] text-white" data-testid="site-footer">
      <div className="container-x grid gap-12 py-16 md:grid-cols-4">
        <div className="md:col-span-2">
          <Logo light />
          <p className="mt-5 max-w-sm text-sm leading-relaxed text-slate-400">Himalayan road trips, spiritual journeys and family holidays, planned from Uttarakhand.</p>
          <div className="mt-6 space-y-2 text-sm">
            <a href={`mailto:${EMAIL}`} className="flex items-center gap-2 text-slate-300 hover:text-[#FD691B]" data-testid="footer-email"><Mail className="h-4 w-4" />Email: {EMAIL}</a>
            <a href={`tel:${PHONE_TEL}`} className="flex items-center gap-2 text-slate-300 hover:text-[#FD691B]" data-testid="footer-phone"><Phone className="h-4 w-4" />Phone: {PHONE}</a>
          </div>
          <div className="mt-6 flex gap-3">
            {socials.map(({ url, Icon, label }) => (
              <a key={label} href={url} target="_blank" rel="noreferrer" aria-label={label} data-testid={`footer-social-${label.toLowerCase()}`}
                 className="grid h-10 w-10 place-items-center rounded-full bg-white/10 transition-colors hover:bg-[#FD691B]"><Icon className="h-4 w-4" /></a>
            ))}
          </div>
        </div>
        <div>
          <h3 className="font-display text-sm font-bold uppercase tracking-widest text-[#FD691B]">Explore</h3>
          <ul className="mt-4 space-y-2.5 text-sm">
            {NAV.map((n) => <li key={n.to}><Link to={n.to} className="text-slate-300 hover:text-white" data-testid={`footer-link-${n.label.toLowerCase().replace(/\s/g, "-")}`}>{n.label}</Link></li>)}
          </ul>
        </div>
        <div>
          <h3 className="font-display text-sm font-bold uppercase tracking-widest text-[#FD691B]">Policies</h3>
          <ul className="mt-4 space-y-2.5 text-sm">
            {POLICIES.map((n) => <li key={n.to}><Link to={n.to} className="text-slate-300 hover:text-white" data-testid={`footer-link-${n.to.slice(1)}`}>{n.label}</Link></li>)}
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="container-x flex flex-col gap-2 py-6 text-xs text-slate-500 sm:flex-row sm:justify-between">
          <span>© {new Date().getFullYear()} Wandervibe Journeys. Uttarakhand, India.</span>
          <span>Submitting an enquiry does not confirm a booking.</span>
        </div>
      </div>
    </footer>
  );
};
